import { render, staticRenderFns } from "./product-details-workflow.vue?vue&type=template&id=612b6ce5&scoped=true&"
import script from "./product-details-workflow.vue?vue&type=script&lang=js&"
export * from "./product-details-workflow.vue?vue&type=script&lang=js&"
import style0 from "./product-details-workflow.vue?vue&type=style&index=0&id=612b6ce5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "612b6ce5",
  null
  
)

export default component.exports